export default __webpack_public_path__ + "static/media/bag2.ef470b6a.jpg";